import type { ReactNode } from 'react';

import type { registerDrawerNavigationGuard } from '../../navigation/navigationHistory';

import { Drawer } from './Drawer';
import { DrawerContextProvider } from './DrawerContextProvider';

interface DrawerAppWrapperProps {
    children: ReactNode;
    registerNavigationGuard?: typeof registerDrawerNavigationGuard;
}

export const DrawerAppWrapper = ({ children, registerNavigationGuard }: DrawerAppWrapperProps) => (
    <DrawerContextProvider registerNavigationGuard={registerNavigationGuard}>
        <Drawer />
        {children}
    </DrawerContextProvider>
);
